// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type LightBulb48Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const LightBulb48: FC<LightBulb48Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="48"
            height="48"
        >
            <path d="M24 44c-1.133 0-2.092-.392-2.875-1.175-.783-.783-1.175-1.742-1.175-2.875h8.1c0 1.133-.392 2.092-1.175 2.875C26.092 43.608 25.133 44 24 44Zm-8.1-7.15v-3h16.2v3H15.9Zm.25-6.05c-2.2-1.433-3.942-3.225-5.225-5.375C9.642 23.275 9 20.85 9 18.15c0-4.067 1.483-7.583 4.45-10.55C16.417 4.633 19.933 3.15 24 3.15c4.067 0 7.583 1.483 10.55 4.45C37.517 10.567 39 14.083 39 18.15c0 2.7-.633 5.125-1.9 7.275-1.267 2.15-3.017 3.942-5.25 5.375h-15.7Zm1.1-3H30.8a11.652 11.652 0 0 0 3.8-4.15c.933-1.7 1.4-3.533 1.4-5.5 0-3.3-1.175-6.125-3.525-8.475C30.125 7.325 27.3 6.15 24 6.15s-6.125 1.175-8.475 3.525C13.175 12.025 12 14.85 12 18.15c0 1.967.467 3.8 1.4 5.5a11.494 11.494 0 0 0 3.85 4.15Z" />
        </svg>
    );
};

export default LightBulb48;
